<div *ngIf="!busy">
    <div class="row margin-top-8" *ngIf="!currentData">
        <div class="col-md-4 label">
            {{'bikeshop.text_message_integration.twilio.accountsid_title' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="accountSID" />
            </div>
            <small>{{'bikeshop.text_message_integration.twilio.account_help_text_1' | translate}} </small>
        </div>
    </div>

    <div class="row margin-top-8" *ngIf="!currentData">
        <div class="col-md-4 label">
            {{'bikeshop.text_message_integration.twilio.authtoken_title' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="authToken" />
            </div>
            <small>{{'bikeshop.text_message_integration.twilio.account_help_text_1' | translate}} </small>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'bikeshop.text_message_integration.twilio.phonenumber_title' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="phoneNumber" />
            </div>
            <small>{{'bikeshop.text_message_integration.twilio.account_help_text_1' | translate}} </small>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'bikeshop.text_message_integration.twilio.phonenumbersid_title' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="phoneNumberSID" />
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4">

        </div>
        <div class="col-md-8">
            <div class="phonenumbersid-help">
                {{'bikeshop.text_message_integration.twilio.account_phonenumbersid_help_text_1' | translate}}
                <ol>
                    <li>{{'bikeshop.text_message_integration.twilio.account_phonenumbersid_help_text_step1' |
                        translate}}</li>
                    <li>{{'bikeshop.text_message_integration.twilio.account_phonenumbersid_help_text_step2' |
                        translate}}</li>
                    <li>{{'bikeshop.text_message_integration.twilio.account_phonenumbersid_help_text_step3' |
                        translate}}</li>
                    <li>{{'bikeshop.text_message_integration.twilio.account_phonenumbersid_help_text_step4' |
                        translate}}</li>
                </ol>
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'bikeshop.text_message_integration.twilio.messagingservicesid_title' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="messagingServiceSID" />                
            </div>
            <small>{{'bikeshop.text_message_integration.twilio.messagingservicesid_description' | translate}} </small>
        </div>
    </div>

    <div id="twilio-two-way-steps" class="row margin-top-8">
        <div class="col-md-4 label" style="margin-top: 0px;">
            {{'bikeshop.text_message_integration.twilio.configure_two_way_sms_steps_title' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="two-way-sms-help" innerHTML="
            {{
            'bikeshop.text_message_integration.twilio.configure_two_way_sms_steps' | translate : { webhookUrl: twilioIncomingWebhookURL }
            }}">
            </div>
        </div>
    </div>

    <div class="row margin-top-8">
        <div class="col-md-4 label">
        </div>
        <div class="col-md-8">
            <button pButton *ngIf="currentData == null" (click)="connect()"
                class="p-button-raised accent centered-button" [disabled]="isValid() || connecting">
                {{'bikeshop.text_message_integration.twilio.connect_button' | translate}}
            </button>

            <button pButton *ngIf="currentData != null" (click)="update()"
                class="p-button-raised accent centered-button" [disabled]="isValid() || updating">
                {{'bikeshop.text_message_integration.twilio.update_button' | translate}}
            </button>
        </div>
    </div>

</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
